import React from "react";

const UniformServiceCardSection4 = (props) => {
  return (
    <div class=" flex mt-24  bg-white lg:w-2/5  pt-4 pb-5 shadow-2xl rounded-lg  ">
      <div class="mx-4 h-full overflow-hidden">
        <img
          class=" h-[30vh] w-[40vh] lg:h-[50vh] lg:w-[35vh] rounded-lg  hover:scale-125 hover:relative ease-in duration-500  "
          src={props.image}
          alt=""
        />
      </div>
      <div class=" lg:p-24 mx-3">
        <h1 class="text-sky-400 font-serif text-2xl cursor-pointer ">
          {props.title}
        </h1>
        {/* <div class="flex justify-between mt-6 text-slate-400 mr-16">
          <div class="flex">
            <img
              class="w-7"
              src="https://images.freeimages.com/clg/istock/previews/7496/74960333-outline-icon-of-calendar.jpg"
              alt=""
            />
            <h6>12 Jan 2021</h6>
          </div>
          <div class="flex ">
            <img
              class="w-7   "
              src="https://icons.veryicon.com/png/o/internet--web/55-common-web-icons/person-4.png"
              alt=""
            />
            <h6>SSPS</h6>
          </div>
        </div> */}
        <h2 class="lg:w-[85%] text-sm lg:text-lg ">
          <ul class="list-disc">
            <li>{props.para}</li>
            <li>{props.para1}</li>
            <li>{props.para2}</li>
            <li>{props.para3}</li>
            {/* <li> {props.para4}</li> */}
          </ul>
        </h2>
      </div>
    </div>
  );
};

export default UniformServiceCardSection4;
